import { DocumentTypes } from 'client/Interfaces/Draft/DraftInterface'

export interface ButtonLabelsInterface {
  back: string
  save: string
  saveEdit: string
  next: string
  previewAndSend: string
  send: string
  sendEdit: string
}

export interface HeadingLabelsInterface {
  create: string
  edit: string
}

export interface LabelInterface {
  entityNumber: string
  invoiceNumber?: string
  receiptNumber?: string
  phases: HeadingLabelsInterface
  buttons: ButtonLabelsInterface
}

export const LabelKeys: Record<DocumentTypes | 'recurringProfile', LabelInterface> = {
  invoice: {
    entityNumber: 'InvoiceNumber',
    phases: {
      create: 'invoice.Create',
      edit: 'invoice.Edit',
    },
    buttons: {
      back: 'Back',
      save: 'SaveAndClose',
      saveEdit: 'save',
      next: 'PreviewAndSend',
      send: 'approveAndSend',
      sendEdit: 'saveAndSend',
    },
  },
  recurringProfile: {
    entityNumber: 'FirstInvoiceNumber',
    phases: {
      create: 'CreateRecurringProfile',
      edit: 'EditRecurringProfile',
    },
    buttons: {
      back: 'Back',
      save: 'SaveAndClose',
      saveEdit: 'save',
      next: 'Preview',
      send: 'approveAndSend',
      sendEdit: 'saveAndSend',
    },
  },
  creditnote: {
    entityNumber: 'InvoiceNumber',
    phases: {
      create: 'CreateCreditnote',
      edit: 'EditCreditnote',
    },
    buttons: {
      back: 'Back',
      save: 'SaveAndClose',
      saveEdit: 'save',
      next: 'Next',
      send: 'approveAndSend',
      sendEdit: 'saveAndSend',
    },
  },
  estimate: {
    entityNumber: 'offer.Number',
    phases: {
      create: 'estimate.Create',
      edit: 'estimate.Edit',
    },
    buttons: {
      back: 'Back',
      save: 'SaveAndClose',
      saveEdit: 'save',
      next: 'Preview',
      send: 'approveAndSend',
      sendEdit: 'saveAndSend',
    },
  },
  receipt: {
    entityNumber: 'ReceiptNumber',
    phases: {
      create: 'receipt.Create',
      edit: 'receipt.Edit',
    },
    buttons: {
      back: 'Back',
      save: 'SaveAndClose',
      saveEdit: 'save',
      next: 'Preview',
      send: 'approveAndSend',
      sendEdit: 'saveAndSend',
    },
  },
  deliverynote: {
    entityNumber: 'DeliveryNoteNumber',
    receiptNumber: 'DeliverynoteEditor.ReceiptNumber',
    invoiceNumber: 'ReceiptEditor.invoiceNumber',
    phases: {
      create: 'deliveryNote.Create',
      edit: 'deliveryNote.Edit',
    },
    buttons: {
      back: 'Back',
      save: 'SaveAndClose',
      saveEdit: 'save',
      next: 'Preview',
      send: 'approveAndSend',
      sendEdit: 'saveAndSend',
    },
  },
}
